import { basicAdminRoutes } from '../../admin/models/basic-admin-routes';
import { Routes } from '@angular/router';
import { moduleConfig } from './module-config';
import { blogRoutes } from 'src/app/blog/models/blog-routes';

export const routes: Routes = [
    {
        path: '',
        loadComponent: () => import('src/app/front/views/layout/layout.component').then(module => module.LayoutComponent),
        children: [
            {
                path: '',
                loadComponent: () => import('src/app/front/views/home/home.component').then(module => module.HomeComponent),
                data: {
                    path: 'home'
                }
            },
            {
                path: $localize`:@@pathAbout:o-firmie`,
                loadComponent: () => import('src/app/front/views/about/about.component').then(module => module.AboutComponent),
                data: {
                    path: 'about'
                }
            },
            {
                path: $localize`:@@pathOffer:oferta`,
                loadComponent: () => import('src/app/front/views/offer/offer.component').then(module => module.OfferComponent),
                data: {
                    path: 'offer'
                }
            },
            {
                path: $localize`:@@pathPromotions:promocje`,
                loadComponent: () => import('src/app/front/views/promotions/promotions.component').then(module => module.PromotionsComponent),
                data: {
                    path: 'promotions'
                }
            },
            {
                path: $localize`:@@pathPromotion:promocja` + '/:url',
                loadComponent: () => import('src/app/front/views/promotion/promotion.component').then(module => module.PromotionComponent),
                data: {
                    path: 'promotion'
                }
            },
            {
                path: $localize`:@@pathChildrenBranch:filia-dziecieca`,
                loadComponent: () => import('src/app/front/views/children-branch/children-branch.component').then(module => module.ChildrenBranchComponent),
                data: {
                    path: 'childrenBranch'
                }
            },
            {
                path: $localize`:@@pathRegulation:regulamin` + '/:url',
                loadComponent: () => import('src/app/front/views/regulation/regulation.component').then(module => module.RegulationComponent),
                data: {
                    path: 'regulation'
                }
            },
            {
                path: $localize`:@@pathRegulations:regulaminy`,
                loadComponent: () => import('src/app/front/views/regulations/regulations.component').then(module => module.RegulationsComponent),
                data: {
                    path: 'regulations'
                }
            },
            ...(moduleConfig.isProductEnabled ? [
                {
                    path: $localize`:@@pathOffer:oferta`,
                    loadComponent: () => import('src/app/rokezzz/product/front/views/offer/offer.component').then(module => module.RokezzzOfferComponent),
                    data: {
                        path: 'offer'
                    },
                    children: [
                        {
                            path: '',
                            loadComponent: () => import('src/app/rokezzz/product/front/views/offer/categories/categories.component').then(m => m.RokezzzCategoriesViewComponent),
                            data: {
                                path: 'offer'
                            }
                        },
                        {
                            path: '' + ':url',
                            loadComponent: () => import('src/app/rokezzz/product/front/views/offer/category-products/category-products.component').then(m => m.RokezzzCategoryProductsViewComponent),
                            data: {
                                path: 'offer',
                                productPath: 'offer.product'
                            }
                        },
                        {
                            path: $localize`:@@pathProduct:produkt` + '/:url',
                            loadComponent: () => import('src/app/rokezzz/product/front/views/offer/simple/simple.component').then(m => m.RokezzzProductSimpleViewComponent),
                            data: {
                                path: 'offer.product',
                                productPath: 'offer.product',
                                offerPath: 'offer'
                            }
                        },
                    ]
                },
            ] : []),
            ...(moduleConfig.isDeleteUserOptionEnabled ? [{
                path: $localize`:@@pathConfirmAccountDeletion:potwierdz-usuniecie-konta`,
                loadComponent: () => import('src/app/rokezzz/user/views/confirm-account-delete/confirm-account-delete.component').then(module => module.RokezzzConfirmAccountDeleteViewComponent),
                data: {
                    path: 'confirmAccountDeletion',
                }
            }] : []),
            ...(moduleConfig.isContactEnabled ? [{
                path: $localize`:@@pathContact:kontakt`,
                loadComponent: () => import('src/app/front/views/contact/contact.component').then(module => module.ContactComponent),
                data: {
                    path: 'contact'
                }
            }] : []),
            ...(moduleConfig.isBlogEnabled ? [...blogRoutes] : []),
        ],
    },
    ...(moduleConfig.isAdminEnabled ? [...basicAdminRoutes] : []),
    {
        path: '**',
        redirectTo: ''
    },
];
